import { constants } from "@newsela/angelou";

const { colors } = constants;

export const textCss = {
  color: colors.ui.core[700],
  marginTop: "5px",
  paddingLeft: "0px",
  ":hover": {
    background: "transparent",
  },
};

export const iconCss = {
  width: "20px",
  height: "20px",
};

export const loadingSpinnerCss = {
  width: "20px",
  height: "20px",
  display: "block",
  margin: "24px 0 18px",
};
